module.exports = __webpack_public_path__ + "img/file-earmark-music.b5c7d9de.svg";